import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Production queue',
  description: 'Displays a production queue'
};



// WEBPACK FOOTER //
// ./app/widgets/ProductionQueue/index.js